// مسار الجوال/الـPWA: نعرض التقرير داخل التطبيق (طبقة React) بلا مغادرة الصفحة.
// التحميل/المشاركة يتمّان بطلب واحد مباشر من HTML الجاهز (renderPdfDirect) — بلا تذكرة/تسخين/استطلاع.
import { shareReport, updateShareHtml } from "../../api/reportShare";
import { openReportOverlay, patchReportOverlay } from "./reportOverlay";

const native = () => {
  try {
    return window.Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
};

export const isMobileReport = () =>
  native()
  || window.innerWidth < 820
  || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || "");

// نرسم التقرير فوراً (build(null)) فيظهر مع أزرار التحميل/المشاركة حالاً،
// ثم نُثري رابط المشاركة (نسخ الرابط) في الخلفية دون إعادة تحميل الـ iframe.
export const openMobileReport = async ({
  title, build, meta = null, fileName = "report", lang = "ar",
}) => {
  const html = build(null);
  openReportOverlay({ html, shareUrl: null, fileName: title || fileName, lang });
  const share = await shareReport(title, "", meta).catch(() => null);
  if (share) {
    patchReportOverlay({ shareUrl: share.short || share.url });
    if (share.token) updateShareHtml(share.token, build(share)).catch(() => {});
  }
  return true;
};
